import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/game',
      name: 'game',
      component: () => import(/* webpackChunkName: "game" */ './views/Game.vue'),
      children: [
        {
          path: 'setup',
          component: () => import(/* webpackChunkName: "game" */ './views/game/Setup.vue')
        },
        {
          path: 'invitation/:gameId',
          component: () => import(/* webpackChunkName: "game" */ './views/game/Invitation.vue')
        },
        {
          path: 'play/:gameId',
          component: () => import(/* webpackChunkName: "game" */ './views/game/Play.vue')
        },
        {
          path: 'spectate/:gameId',
          component: () => import(/* webpackChunkName: "game" */ './views/game/Spectate.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const auth = store.getters['auth/authorized']
  if (to.matched.reduce(
    (acc, r) => (r.meta.requiresAuth !== undefined ? r.meta.requiresAuth : acc),
    false
  )) {
    if (!auth) {
      store.dispatch('notifications/push', {
        type: 'error',
        message: 'You have to be logged in to view this page!'
      })
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else if (to.matched.reduce(
    (acc, r) => (r.meta.requiresAuth !== undefined ? r.meta.requiresUnauthorized : acc),
    false
  )) {
    if (auth) {
      store.dispatch('notifications/push', {
        type: 'error',
        message: 'You must not be logged in to view this page!'
      })
      next(false)
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
